export default "__VITE_ASSET__r0Q18CZA__"